export function searchWidgetConfigSelector(state = {}) {
  return state.searchWidgetConfig || null;
}
